const STORAGE_KEY = 'dailylife_translate_settings';

export type TranslateSettings = {
  /** Optional — MyMemory raises free quota from 5k to 50k chars/day per device. */
  contactEmail: string;
};

export function loadTranslateSettings(): TranslateSettings {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return { contactEmail: '' };
  try {
    const o = JSON.parse(raw) as Partial<TranslateSettings> & {
      apiKey?: string;
      baseUrl?: string;
    };
    if (typeof o.contactEmail === 'string') {
      return { contactEmail: o.contactEmail.trim() };
    }
    return { contactEmail: '' };
  } catch {
    return { contactEmail: '' };
  }
}

export function saveTranslateSettings(settings: TranslateSettings): void {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      contactEmail: settings.contactEmail.trim(),
    })
  );
}
